import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import LandscapeBaseTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { LandscapeIndicatorsOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import { Button } from '../../atoms';
import styles from './LandscapeIndicatorsTemplate.module.css';

interface SubListItem {
  compactIndicatorId: string;
  id: string;
  title: string;
  sortOrder: number;
  description: string;
}

interface ListItem {
  id: string;
  title: string;
  sortOrder: number;
  subListItems: SubListItem[];
}

interface LandscapeIndicatorsTemplateProps {
  setShow: (show: boolean) => void;
  listItems: ListItem[];
  setListItems: (items: ListItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  setChangeOrderEnabled: (enabled: boolean) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string) => void;
}

const LandscapeIndicatorsTemplate: FC<LandscapeIndicatorsTemplateProps> = ({
  setShow,
  listItems,
  setListItems,
  changeOrderEnabled,
  setChangeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseTemplate>
          <div className={styles.buttonRow}>
            <Button
              variant="dark"
              onClick={() => setChangeOrderEnabled(!changeOrderEnabled)}
            >
              Change order
            </Button>
            <Button variant="dark" onClick={() => setShow(true)}>
              Add Indicator
            </Button>
          </div>
          <LandscapeIndicatorsOrganism
            listItems={listItems}
            setListItems={setListItems}
            changeOrderEnabled={changeOrderEnabled}
            setChangeOrderEnabled={setChangeOrderEnabled}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        </LandscapeBaseTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorsTemplate;
